export default "__VITE_ASSET__BpxY4vcn__"